import React from 'react';
import {
  Typography,
  Grid,
  Paper,
  Box
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(3),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  welcomeBox: {
    padding: theme.spacing(4),
    textAlign: 'center',
    background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
    color: 'white',
    borderRadius: theme.spacing(1),
  },
}));

const Dashboard = () => {
  const classes = useStyles();

  return (
    <div>
      <Typography variant="h4" gutterBottom>
        Dashboard
      </Typography>
      
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper className={classes.welcomeBox}>
            <Typography variant="h5" gutterBottom>
              Welcome to GIC PhotoAI Admin Panel
            </Typography>
            <Typography variant="body1">
              Manage your application settings, users, and user flags from here.
            </Typography>
          </Paper>
        </Grid>
        
        <Grid item xs={12} sm={6} md={3}>
          <Paper className={classes.paper}>
            <Typography variant="h6">
              Settings
            </Typography>
            <Typography variant="body2">
              Configure your application settings
            </Typography>
          </Paper>
        </Grid>
        
        <Grid item xs={12} sm={6} md={3}>
          <Paper className={classes.paper}>
            <Typography variant="h6">
              Users
            </Typography>
            <Typography variant="body2">
              View and manage registered users
            </Typography>
          </Paper>
        </Grid>
        
        <Grid item xs={12} sm={6} md={3}>
          <Paper className={classes.paper}>
            <Typography variant="h6">
              User Flags
            </Typography>
            <Typography variant="body2">
              Manage user flags and permissions
            </Typography>
          </Paper>
        </Grid>
        
        <Grid item xs={12} sm={6} md={3}>
          <Paper className={classes.paper}>
            <Typography variant="h6">
              System Status
            </Typography>
            <Typography variant="body2" style={{ color: 'green' }}>
              All systems operational
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};

export default Dashboard;